/* Canvono product-media + gallery helper (v34).
   1) Sets --cvn-thumbs to the number of VISIBLE thumbnails for the current variant (4 or 5).
   2) Moves the active-thumbnail highlight the instant the main image arrow is clicked.
   3) Keeps the product TITLE in the info column at every width (v58 — it was lifted above the
      photo below 990px, which broke the 750–989px two-column layout).
   4) GALLERY CENTERING (collection-designs / type-designs, desktop landscape only): when no
      product row fills the width of its column, shrink the rows column to the WIDEST row's
      content width and center the whole block (hero photo + rows) in the screen. Portrait/phone
      untouched.
   All of the above re-run after CLIENT-SIDE navigation (the store swaps pages without a full
   reload, so a one-time DOMContentLoaded pass is not enough) via a body observer + popstate. */
(function () {
  function setCount() {
    document.querySelectorAll('.product__media-wrapper').forEach(function (wrap) {
      var n = 0;
      wrap.querySelectorAll('.thumbnail-list__item').forEach(function (li) {
        if (getComputedStyle(li).display !== 'none') n++;
      });
      if (n > 0) wrap.style.setProperty('--cvn-thumbs', n);
    });
  }

  function activeEl(li) {
    return li.querySelector('[aria-current]') || li.querySelector('button, .thumbnail, a');
  }

  function onArrow(e) {
    var btn = e.target.closest('media-gallery slider-component:not(.thumbnail-slider) .slider-button');
    if (!btn) return;
    var gallery = btn.closest('media-gallery');
    if (!gallery) return;
    var thumbs = Array.prototype.slice
      .call(gallery.querySelectorAll('.thumbnail-list__item'))
      .filter(function (li) { return getComputedStyle(li).display !== 'none'; });
    if (!thumbs.length) return;
    var els = thumbs.map(activeEl);
    var cur = -1;
    for (var i = 0; i < els.length; i++) {
      if (els[i] && els[i].getAttribute('aria-current') === 'true') { cur = i; break; }
    }
    if (cur < 0) cur = 0;
    var dir = btn.classList.contains('slider-button--next') ? 1 : -1;
    var nx = cur + dir;
    if (nx < 0 || nx >= els.length) return;
    els.forEach(function (a) { if (a) a.removeAttribute('aria-current'); });
    if (els[nx]) els[nx].setAttribute('aria-current', 'true');
  }

  /* Put the product title where it belongs: inside the info column, as the first child so it
     sits above price/share/variants — at EVERY width (v58). Idempotent — only moves it when
     it is in the wrong place.
     ⚠️ This used to lift the title out to `.product` below 990px, "on top for mobile". Dawn's
     layout goes two-column at 750px, so on a 750–989px window (a small laptop, the extension
     pane, a tablet in landscape) the title sat ABOVE the photo AND the info column while the
     page was still two columns — and it ran before main-product's own ≤749 lift, so its move
     was the one that stuck. On phone (≤749) the v58 decision is the same: the title lives in
     the info column (cvn-pdp-mobile-title §7 re-homes it after main-product's lift). */
  function positionTitle() {
    var product = document.querySelector('.product');
    if (!product) return;
    var infoContainer = product.querySelector('.product__info-container');
    if (!infoContainer) return;
    var title = product.querySelector(':scope > .product__title')
      || infoContainer.querySelector(':scope > .product__title');
    if (!title) return;
    if (title.parentElement !== infoContainer || infoContainer.firstElementChild !== title) {
      infoContainer.insertBefore(title, infoContainer.firstChild);
    }
  }

  /* ---- GALLERY CENTERING ---------------------------------------------------------------- */
  /* Natural content width of a horizontal carousel (works even when it is UNDER-filled, where
     scrollWidth would just report the box width): sum the card widths + the flex gaps + the
     track's own left/right padding. */
  function contentWidth(track) {
    var kids = track.children, n = 0, sum = 0;
    for (var i = 0; i < kids.length; i++) {
      var r = kids[i].getBoundingClientRect();
      if (r.width > 0) { sum += r.width; n++; }
    }
    if (!n) return 0;
    var cs = getComputedStyle(track);
    var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 16;
    var pl = parseFloat(cs.paddingLeft) || 0;
    var pr = parseFloat(cs.paddingRight) || 0;
    return sum + gap * (n - 1) + pl + pr;
  }

  function centerOne(wrap) {
    var layout = wrap.querySelector(':scope > .cvn-layout') || wrap.querySelector('.cvn-layout');
    if (!layout) return;
    /* Always reset first, then re-measure against the natural full-width state. Resetting each
       run is what stops the shrink from feeding back into the next measurement (oscillation). */
    layout.style.removeProperty('grid-template-columns');
    layout.style.removeProperty('justify-content');
    /* Only the desktop GRID mode is eligible — portrait/phone collapse .cvn-layout to a block,
       and there the hero is hidden, so leave it completely alone. */
    if (getComputedStyle(layout).display !== 'grid') return;
    var carousels = Array.prototype.filter.call(
      layout.querySelectorAll('.cvn-carousel[data-track]'),
      function (c) { return c.offsetParent !== null && c.clientWidth > 0; }
    );
    if (!carousels.length) return;
    var colWidth = carousels[0].clientWidth; /* natural (reset) rows-column width */
    var maxContent = 0;
    carousels.forEach(function (t) { var w = contentWidth(t); if (w > maxContent) maxContent = w; });
    if (maxContent <= 0) return;
    /* A row already fills (or overflows) the column -> leave the full-width layout as-is. */
    if (maxContent >= colWidth - 1) return;
    var hero = layout.querySelector('.cvn-hero');
    var heroW = hero ? Math.round(hero.getBoundingClientRect().width) : 0;
    if (heroW <= 0) return;
    layout.style.setProperty('grid-template-columns', heroW + 'px ' + Math.ceil(maxContent) + 'px');
    layout.style.setProperty('justify-content', 'center');
  }

  function centerGalleries() {
    document.querySelectorAll('.cvn-nwrap').forEach(centerOne);
  }

  /* ---- HERO LAYER SELF-HEAL — RETIRED (theme audit v77) ----------------------------------
     The crossTo() race it papered over (a manually-called onload left attached, so the in-flight
     load ran it again and turned the shown layer off) is fixed at the root in type-designs and
     collection-designs: show() detaches itself. Nothing to heal from outside any more. */

  /* ---- wiring (idempotent, survives client-side nav) ------------------------------------ */
  var wiredThumbs = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;
  var wiredWraps = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;

  function wireThumbLists() {
    document.querySelectorAll('.product__media-wrapper .thumbnail-list').forEach(function (list) {
      if (wiredThumbs) { if (wiredThumbs.has(list)) return; wiredThumbs.add(list); }
      var mo = new MutationObserver(function () { setCount(); });
      mo.observe(list, { attributes: true, subtree: true, attributeFilter: ['style', 'class', 'hidden'] });
    });
  }
  /* A type page switches its breakdown by showing/hiding a .cvn-dim block, which changes which
     rows are visible — re-center when that happens. */
  function wireWraps() {
    document.querySelectorAll('.cvn-nwrap').forEach(function (wrap) {
      if (wiredWraps) { if (wiredWraps.has(wrap)) return; wiredWraps.add(wrap); }
      var mo = new MutationObserver(function () { setTimeout(function () { centerOne(wrap); }, 0); });
      mo.observe(wrap, { attributes: true, subtree: true, attributeFilter: ['hidden'] });
    });
  }

  /* Everything that must be (re)applied on load AND after every client-side page swap. */
  function refresh() {
    setCount();
    positionTitle();
    centerGalleries();
    wireThumbLists();
    wireWraps();
  }

  /* Did a mutation batch actually swap in a gallery / product / main region (a real page
     change), rather than a cart drawer, search dropdown, or image-rotation attribute change? */
  function isPageSwap(muts) {
    for (var i = 0; i < muts.length; i++) {
      var a = muts[i].addedNodes;
      for (var j = 0; j < a.length; j++) {
        var n = a[j];
        if (!n || n.nodeType !== 1) continue;
        if (n.matches && n.matches('.cvn-nwrap, .product, #MainContent, .shopify-section')) return true;
        if (n.querySelector && n.querySelector('.cvn-nwrap, .product')) return true;
      }
    }
    return false;
  }

  function init() {
    refresh();

    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('.product-form, variant-selects, variant-radios')) {
        setTimeout(setCount, 60);
      }
    });
    document.addEventListener('click', onArrow, true);

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { positionTitle(); centerGalleries(); }, 120);
    });

    /* CLIENT-SIDE NAVIGATION: the store replaces the page content without a full reload, so
       re-run everything whenever a new gallery/product/section is inserted. Debounced + filtered
       so ordinary UI (cart, search, image rotation) does not trigger it. */
    var nt;
    var bodyObs = new MutationObserver(function (muts) {
      if (!isPageSwap(muts)) return;
      clearTimeout(nt);
      nt = setTimeout(function () { refresh(); setTimeout(centerGalleries, 250); }, 120);
    });
    bodyObs.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('popstate', function () { setTimeout(refresh, 150); });

    /* Late passes in case the theme's own script repositions things or images settle sizes. */
    setTimeout(refresh, 300);
    setTimeout(centerGalleries, 800);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
